import { FC } from 'react';
import { Checkbox } from 'antd';

import { Option } from 'models/form';

type CheckBoxGroupProps = {
	onChange?: ((e: any) => void) | undefined;
	options: Option[];
	id?: string;
	value?: string[];
};

export const CheckBoxGroup: FC<CheckBoxGroupProps> = ({ onChange, options, id, value }) => {
	return (
		<div id={id}>
			<Checkbox.Group
				value={value}
				options={options}
				onChange={(v: any) => {
					if (onChange) {
						onChange(v);
					}
				}}
			/>
		</div>
	);
};
